import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { BsTelephoneInboundFill, BsTelephoneOutbound } from "react-icons/bs";

import Lead from "../../../shared/Lead";
import AudioControl from "./AudioControl";

const CallItem = ({ task }) => {
  return (
    <Col md={3} sm={4} className="bl  bt">
      <small id="from" className="mb5">
        {task.phone_call.support_agent &&
          task.phone_call.support_agent.first_name + " " + task.phone_call.support_agent.last_name}
      </small>
      <br />
      {task.phone_call.type ? (
        <Lead
          message={task.phone_call.type + " call "}
          small={new Date(task.created_at).toLocaleString([], {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          })}
        />
      ) : (
        <label>Voice Recording</label>
      )}
      <div className="mt10">
        <b>
          {" "}
          <BsTelephoneOutbound className="phone-number-icon" />
          From{" "}
        </b>
        {task.phone_call && task.phone_call.from}
        {"   "}

        <b>
          {" "}
          <BsTelephoneInboundFill className="phone-number-icon ml20" />
          To{" "}
        </b>
        {task.phone_call && task.phone_call.to}
      </div>
      {task.phone_call.recording_url && (
        <AudioControl
          url={`${task.phone_call.recording_url}`}
          id={`call-item-${ task.id }`}
          caller={task.phone_call.from}
        />
      )}
    </Col>
  );
};
export default CallItem;
